import { useEffect, useState } from 'react';
import InvitesMemberService from '../../services/InvitesService';
import Invites from '../../types/Invites';

export default function useInvites() {
    const [loading, setLoading] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const [invites, setInvites] = useState<Invites>();

    const load = async () => {
        try {
            const response = await InvitesMemberService.getAllInvites();
            setInvites(response);
            setError(null);
        } catch (e: any) {
            setError(e);
        }
    };

    const refresh = () => {
        setUpdating(true);
        load();
        setUpdating(false);
    };

    useEffect(() => {
        const init = async () => {
            setLoading(true);
            await load();
            setLoading(false);
        };

        init();
    }, []);

    return { invites, refresh, loading, updating, error };
}
